// extracted by mini-css-extract-plugin
export default {"outerWrapper":"styles_outerWrapper__wCxWF","templateWrapper":"styles_templateWrapper__RzNPm"};